<template>
  <b-carousel
    controls
    indicators
    background="#ababab"
    img-width="1200"
    img-height="550"
    style="text-shadow: 1px 1px 2px #333;"
    :interval="4000"
  >
    <b-carousel-slide
      caption="Inspección Técnica"
      text="Expertos a su servicio"
      img-src="../assets/carrusel/b1a.jpg"
    ></b-carousel-slide>

    <b-carousel-slide
      caption="Administración de Contratos"
      text="Productos y soluciones de calidad"
      img-src="../assets/carrusel/b3a.jpg"
    ></b-carousel-slide>

    <b-carousel-slide
      caption="Gerencia de Proyectos"
      text="Seguimiento integral del proyecto"
      img-src="../assets/carrusel/b2a.jpg"
    ></b-carousel-slide>
  </b-carousel>
</template>

<script>
export default {
  name: "carrusel",
};
</script>

